// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */

import {
  ClassDetailsNoSectionsQuery,
  ClassDetailsNoSectionsQueryVariables
} from "@outschool/gql-frontend-generated";
import { isUuid } from "@outschool/text";
import { ApolloError, useQueryWithPreviousData } from "@outschool/ui-apollo";
import { useFundingProgramAbbr, useSession } from "@outschool/ui-auth";
import { ClassDetailsQueryNoSections } from "@outschool/ui-components-website";
import React from "react";
import { useParams } from "react-router-dom";

import * as Routes from "../../shared/Routes";

type ClassDetailsActivity = ClassDetailsNoSectionsQuery["activity"];

export function useClassDetails(activitySlugOrUid?: string) {
  const { currentUser, currentUserHasLoaded } = useSession();
  const [uid, slugId] = React.useMemo(() => {
    if (!activitySlugOrUid) {
      return [undefined, undefined];
    }
    return isUuid(activitySlugOrUid)
      ? [activitySlugOrUid, undefined]
      : [undefined, Routes.getIdFromSlug(activitySlugOrUid)];
  }, [activitySlugOrUid]);
  const esaState = useFundingProgramAbbr();
  const variables: ClassDetailsNoSectionsQueryVariables = React.useMemo(
    () => ({
      uid,
      slugId,
      esaState
    }),
    [uid, slugId, esaState]
  );
  const shouldRunQuery = !!(uid || slugId || currentUserHasLoaded);

  const { error, loading, data } = useQueryWithPreviousData<
    ClassDetailsNoSectionsQuery,
    ClassDetailsNoSectionsQueryVariables
  >(ClassDetailsQueryNoSections, {
    variables: {
      ...variables,
      fundingPrograms: currentUser?.esaMembershipPrograms
    },
    fetchPolicy: "cache-and-network",
    skip: !shouldRunQuery
  });

  return {
    activity: data?.activity,
    error,
    loading
  };
}

type Context = {
  activity: ClassDetailsActivity | undefined;
  error: ApolloError | undefined;
  loading: boolean;
};

const ActivityDetailPageContext = React.createContext<Context>({
  activity: undefined,
  error: undefined,
  loading: true,
  // @ts-ignore TS(2322): Type 'undefined' is not assignable to type 'Exact<... Remove this comment to see the full error message
  variables: undefined
});

export const ActivityDetailPageProvider: React.FC<
  React.PropsWithChildren<{}>
> = ({ children }) => {
  const params = useParams<{
    activitySlugOrUid: string;
  }>();
  const { activity, loading, error } = useClassDetails(
    params.activitySlugOrUid
  );

  return (
    <ActivityDetailPageContext.Provider
      value={{
        activity,
        error,
        loading
      }}
    >
      {children}
    </ActivityDetailPageContext.Provider>
  );
};

export const useActivityDetailPageContext = () => {
  return React.useContext(ActivityDetailPageContext);
};
